/**
 * Testing updating the product details page to increase add to bag
 */
export const OWF_IMPROVE_TERMS_TOUCHPOINTS_PDP_240528 = 'OWF_IMPROVE_TERMS_TOUCHPOINTS_PDP_240528';
